import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useServiceWorker } from './useServiceWorker';
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';
// A fixed id so the update prompt can only ever appear once, and so the dismiss
// call below is unmistakably paired with it. This was the bare literal 1.
var SW_UPDATE_TOAST = "sw-update";
function RefreshButton() {
    // refresh page message
    var _a = useServiceWorker(), waitingWorker = _a.waitingWorker, showReload = _a.showReload, reloadPage = _a.reloadPage;
    React.useEffect(function () {
        if (showReload && waitingWorker) {
            var Msg = function () { return (_jsxs("div", { children: [_jsx("h4", { children: "New Version Available" }), "A new version of the portal is ready. Refresh to load it.", " ", _jsx(Button, { variant: "outline-primary", size: "sm", onClick: function () { reloadPage(); }, children: "Refresh Now" })] })); };
            toast.info(_jsx(Msg, {}), {
                position: "bottom-right",
                autoClose: false,
                closeOnClick: false,
                theme: "light",
                toastId: SW_UPDATE_TOAST
            });
        }
        else {
            toast.dismiss(SW_UPDATE_TOAST);
        }
    }, [waitingWorker, showReload, reloadPage]);
    return (_jsx(ToastContainer, {}));
}
export default RefreshButton;
